import React,{ useState } from "react";

function CookieConsentBanner() {
  const [visible, setVisible] = useState(
    () => !localStorage.getItem("all3d_analytics_consent")
  );

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem("all3d_analytics_consent", "accepted");
    setVisible(false);
    window.location.reload();
  };

  const handleReject = () => {
    localStorage.setItem("all3d_analytics_consent", "rejected");
    setVisible(false);
  };

  const buttonStyle = {
    color: "#ffffff",
    fontSize: "18px",
    borderRadius: "4px",
    fontWeight: "normal",
    padding: "8px 30px",
    border: "none",
    cursor: "pointer",
    minWidth: "120px",
  };

  return (
    <div
      role="dialog"
      aria-label="Analytics consent"
      aria-describedby="consent-description"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#353535",
        color: "#ffffff",
        padding: "24px 32px",
        zIndex: 9999,
        boxShadow: "0 -2px 10px rgba(0,0,0,0.3)",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <p id="consent-description" style={{ flex: 1, minWidth: "280px", fontSize: "14px", lineHeight: "1.5", marginBottom: 0 }}>
          We use analytics cookies (PostHog) to improve your experience. We do not sell your
          personal information. See our{" "}
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline", color: "#ffffff" }}
          >
            Privacy Policy
          </a>
          .
        </p>
        <div style={{ display: "flex", gap: "12px", flexShrink: 0 }}>
          <button onClick={handleReject} style={{ ...buttonStyle, background: "#666666" }}>
            Reject
          </button>
          <button onClick={handleAccept} style={{ ...buttonStyle, background: "#276DD7" }}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
